import React from 'react';
import Layout from '@/Shared/Layout';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import PaginateCount from '@/Shared/PaginateCount';
import Pagination from '@/Shared/Pagination';
import TableHeadSort from '@/Shared/TableHeadSort';
import { openModal } from '@/Store/Slices/ModalSlice';
import { useDispatch } from 'react-redux';
import FeaturedCouponsBtns from '@/Pages/Categories/Assets/FeaturedCouponsBtns';
import useCheckbox from '@/Hooks/useCheckbox';
import FeaturedCouponsBottomPanel from '@/Pages/Categories/Assets/FeaturedCouponsBottomPanel';
import FeaturedCouponsSearchFilter from '@/Pages/Categories/Assets/FeaturedCouponsSearchFilter';

const FeaturedCoupons = () => {
  const { coupons, discount_types, category } = usePage().props;

  const {
    data,
    meta: { links }
  } = coupons;

  const dispatch = useDispatch();

  const openFindCouponModal = () => {
    dispatch(openModal({
      modalType: 'find-coupon',
      modalProps: {
        categoryId: category.category_id
      }
    }));
  };

  const {
    checked,
    checkboxesParent,
    handleCheck,
    handleCheckAll,
    parentCheckbox
  } = useCheckbox(data, 'coupon_id');

  return (
    <div>
      <div className='mb-3 flex justify-between items-center	'>
        <h1 className='text-3xl font-bold'>Featured Coupons</h1>
        <button
          className='btn-default focus:outline-none'
          onClick={openFindCouponModal}
        >
          <span>Add</span>
          <span className='hidden md:inline'> Coupon</span>
        </button>
      </div>
      <span>

      </span>
      <div className='flex items-center justify-between mb-6'>
        <FeaturedCouponsSearchFilter discountTypes={discount_types} categoryId={category.category_id}/>

        <PaginateCount />
      </div>

      <div className='overflow-x-auto bg-white rounded shadow'>
        <table className='w-full table-auto text-sm'>
          <thead>
          <tr className='font-bold text-left'>
            <th className='px-1 pt-5 pb-4 w-1'>_</th>
            <TableHeadSort itemId={category.category_id} customClassName='px-1 pt-5 pb-4 w-1' sortName='id' title='ID' />
            <TableHeadSort itemId={category.category_id} customClassName='px-1 pt-5 pb-4 w-1' sortName='code' title='Code' />
            <TableHeadSort itemId={category.category_id} customClassName='px-1 pt-5 pb-4 w-80' sortName='description' title='Description' />
            <TableHeadSort itemId={category.category_id} customClassName='px-1 pt-5 pb-4 w-3' sortName='cat_order' title='Order' />
            <th className='px-1 pt-5 pb-4'>Actions</th>
          </tr>
          </thead>
          <FeaturedCouponsBottomPanel parentCheckbox={parentCheckbox} checked={checked}
                                      handleCheckAll={handleCheckAll} />
          <tbody ref={checkboxesParent}>
          {data.map(({
                       code,
                       coupon_id,
                       meta_description,
                       cat_relation
                     }) => (
            <tr
              key={coupon_id}
              className='hover:bg-gray-100 focus-within:bg-gray-100'
            >
              <td className='border-t'>
                <div className='flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none'>
                  <input
                    type="checkbox"
                    name={coupon_id}
                    onChange={handleCheck} />
                </div>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  // href={route('public.coupons.edit', coupon_id)}
                >
                  {coupon_id}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='-1'
                  // href={route('public.coupons.edit', coupon_id)}
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                >
                  {code}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <InertiaLink
                  tabIndex='-1'
                  // href={route('public.coupons.edit', coupon_id)}
                  className='flex items-center px-1 focus:outline-none'
                >
                  {meta_description}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <InertiaLink
                  tabIndex='-1'
                  // href={route('public.coupons.edit', coupon_id)}
                  className='flex items-center px-1 focus:outline-none'
                >
                  {cat_relation[0].cat_order}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <FeaturedCouponsBtns coupon_id={coupon_id} id={category.category_id} />
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className='px-1 py-4 border-t' colSpan='4'>
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      <Pagination links={links} />
    </div>
  );
};

FeaturedCoupons.layout = page => <Layout title='Featured Coupons' children={page} />;

export default FeaturedCoupons;
